module.exports = __webpack_public_path__ + "img/1.3e3c9b26.png";